export class ArraySerializer {
  public static serialize(arr?: string[]): string {
    return arr?.join(',') || '';
  }

  public static deserialize(str?: string): string[] | undefined {
    if (!str) {
      return undefined;
    }

    return str?.split(',').map((s) => s.trim());
  }
}
